module.exports = __webpack_public_path__ + "static/media/flamingo-upsp2.bd5403c8.jpg";